import React from 'react'
import { Container } from '@headtrip/components-react'
import * as PropTypes from 'prop-types'

export default function SupplementSection (props) {
  let classnames = props.className || ''

  return <Container style={{ height: 0 }}>
    <div className={`supplement-section color-${props.color} ${classnames}`} />
  </Container>
}

SupplementSection.propTypes = {
  color: PropTypes.string.isRequired
}
